//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import viewportMixin from '@/mixins/viewport.mixin';
import RadioCheckGroup from './radioCheckGroup.vue';

export default {
  components: { RadioCheckGroup },
  mixins: [viewportMixin],
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    display: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    itemText: {
      type: String,
      default: '',
    },
    itemValue: {
      type: String,
      default: '',
    },
    model: {
      type: [String, Number, Array],
      default: '',
    },
  },
  data() {
    return {
      localModel: {},
    };
  },
  watch: {
    options: {
      handler() {
        this.fillOptions();
      },
    },
    model: {
      handler() {
        this.fillOptions();
      },
      immediate: true,
    },
  },
  methods: {
    select() {
      if (!this.multiple) {
        this.$emit('input', this.localModel);
      } else {
        const model = [];

        for (let [key, value] of Object.entries(this.localModel)) {
          if (value) {
            const option = this.options.find(
              (i) => i[this.itemValue] === key || i[this.itemValue] === +key,
            );
            if (option) model.push(option[this.itemValue]);
          }
        }

        this.$emit('input', model);
      }

      this.$emit('update:display', false);
    },
    onRadioInput(fieldName) {
      this.localModel = fieldName;
    },
    fillOptions() {
      if (!this.multiple) {
        this.localModel = this.model;
        return;
      }

      const localModel = {};
      for (let i = 0; i < this.options.length; i++) {
        const item = this.options[i];
        const name = item[this.itemValue] || 'all';

        let value = false;
        if (this.model) {
          if (this.multiple) {
            if (this.model.includes(name)) value = true;
          }
        }

        localModel[name] = value;
      }

      this.localModel = localModel;
    },
  },
};
